import { render, staticRenderFns } from "./public-mobile.vue?vue&type=template&id=c09df06e&scoped=true&"
import script from "./public-mobile.vue?vue&type=script&lang=js&"
export * from "./public-mobile.vue?vue&type=script&lang=js&"
import style0 from "./public-mobile.vue?vue&type=style&index=0&id=c09df06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09df06e",
  null
  
)

export default component.exports